import { useGetApiV1GroupsByGroupIdRulesQuery } from '../../api/rules'

type UseGroupRulesProps = {
  groupId?: string
}

const useGroupRules = ({ groupId }: UseGroupRulesProps) => {
  const { data: rules, isLoading } = useGetApiV1GroupsByGroupIdRulesQuery(
    {
      groupId: groupId || '',
    },
    {
      skip: !groupId,
    },
  )

  return { rules: rules ?? null, isLoading }
}

export default useGroupRules
